export default __webpack_public_path__ + "static/media/cp_geo_vg.37b510b2.svg";